import ApiService from './ApiService'

export const getApiData = (data) => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map((sort) => {
            if (!sort.order) return sort
            datas.ordering =
                sort.order === 'desc' ? `-${sort.key}` : `${sort.key}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab) {
            datas.status = data.selectedTab
        }
    }
    return ApiService.get('/company/company-configuration/', datas)
}
export const createApiRecord = (data) =>
    ApiService.post('/company/company-configuration/', data)
export const getApiRecord = (id) =>
    ApiService.get(`/company/company-configuration/${id}`)
export const updateApiRecord = (id, data) =>
    ApiService.put(`/company/company-configuration/${id}/`, data)
export const updateApiStatus = (id, data) =>
    ApiService.patch(`/company/company-configuration/${id}/`, data)
export const deleteApiRecord = (id) =>
    ApiService.delete('/company/company-configuration', id)
